"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var common_1 = require("../../common");

var solver_1 = require("../../solver");

var Specification = require("../../specification");

var index_1 = require("./index");

var LinearScale =
/*#__PURE__*/
function (_index_1$ScaleClass) {
  _inherits(LinearScale, _index_1$ScaleClass);

  function LinearScale() {
    var _this;

    _classCallCheck(this, LinearScale);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LinearScale).apply(this, arguments));
    _this.attributeNames = ["rangeMin", "rangeMax"];
    _this.attributes = {
      rangeMin: {
        name: "rangeMin",
        type: Specification.AttributeType.Number,
        defaultValue: 0
      },
      rangeMax: {
        name: "rangeMax",
        type: Specification.AttributeType.Number
      }
    };
    return _this;
  }

  _createClass(LinearScale, [{
    key: "mapDataToAttribute",
    value: function mapDataToAttribute(data) {
      var attrs = this.state.attributes;
      var props = this.object.properties;
      var x1 = props.domainMin;
      var x2 = props.domainMax;
      var y1 = attrs.rangeMin;
      var y2 = attrs.rangeMax;
      return (data - x1) / (x2 - x1) * (y2 - y1) + y1;
    }
  }, {
    key: "buildConstraint",
    value: function buildConstraint(data, target, solver) {
      var attrs = this.state.attributes;
      var props = this.object.properties;
      var x1 = props.domainMin;
      var x2 = props.domainMax;
      var k = (data - x1) / (x2 - x1);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, target]], [[1 - k, solver.attr(attrs, "rangeMin")], [k, solver.attr(attrs, "rangeMax")]]);
    }
  }, {
    key: "initializeState",
    value: function initializeState() {
      var attrs = this.state.attributes;
      attrs.rangeMin = 0;
      attrs.rangeMax = 100;
    }
  }, {
    key: "inferParameters",
    value: function inferParameters(column) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attrs = this.state.attributes;
      var props = this.object.properties;
      var s = new common_1.Scale.LinearScale();
      var values = column.filter(function (x) {
        return typeof x == "number";
      });
      s.inferParameters(values);
      s.adjustDomain(options);
      props.domainMin = s.domainMin;
      props.domainMax = s.domainMax;

      if (!options.reuseRange) {
        if (options.rangeNumber) {
          attrs.rangeMin = options.rangeNumber[0];
          attrs.rangeMax = options.rangeNumber[1];
        } else {
          attrs.rangeMin = 0;
          attrs.rangeMax = 100;
        }

        this.object.mappings.rangeMin = {
          type: "value",
          value: 0
        };

        if (!options.autoRange) {
          this.object.mappings.rangeMax = {
            type: "value",
            value: attrs.rangeMax
          };
        }
      }
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      return [manager.sectionHeader("Domain"), manager.row("Start", manager.inputNumber({
        property: "domainMin"
      })), manager.row("End", manager.inputNumber({
        property: "domainMax"
      })), manager.sectionHeader("Range"), manager.mappingEditor("Start", "rangeMin", {
        defaultValue: 0
      }), manager.mappingEditor("End", "rangeMax", {
        defaultAuto: true
      })];
    }
  }, {
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var parameters = _get(_getPrototypeOf(LinearScale.prototype), "getTemplateParameters", this).call(this);

      if (!parameters.properties) {
        parameters.properties = [];
      }

      parameters.properties.push({
        objectID: this.object._id,
        target: {
          property: "domainMin"
        },
        type: Specification.AttributeType.Number
      });
      parameters.properties.push({
        objectID: this.object._id,
        target: {
          property: "domainMax"
        },
        type: Specification.AttributeType.Number
      });
      return parameters;
    }
  }]);

  return LinearScale;
}(index_1.ScaleClass);

LinearScale.classID = "scale.linear<number,number>";
LinearScale.type = "scale";
LinearScale.defaultMappingValues = {
  rangeMin: 0
};
exports.LinearScale = LinearScale;

function getDefaultGradient() {
  return {
    colorspace: "lab",
    colors: [{
      r: 255,
      g: 255,
      b: 255
    }, {
      r: 0,
      g: 0,
      b: 0
    }]
  };
}

var LinearColorScale =
/*#__PURE__*/
function (_index_1$ScaleClass2) {
  _inherits(LinearColorScale, _index_1$ScaleClass2);

  function LinearColorScale() {
    var _this2;

    _classCallCheck(this, LinearColorScale);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(LinearColorScale).apply(this, arguments));
    _this2.attributeNames = [];
    _this2.attributes = {};
    return _this2;
  }

  _createClass(LinearColorScale, [{
    key: "mapDataToAttribute",
    value: function mapDataToAttribute(data) {
      var props = this.object.properties;
      var x1 = props.domainMin;
      var x2 = props.domainMax;
      var t = (data - x1) / (x2 - x1);
      var c = common_1.interpolateColors(props.range.colors, props.range.colorspace);
      return c(t);
    }
  }, {
    key: "buildConstraint",
    value: function buildConstraint(data, target, solver) {}
  }, {
    key: "initializeState",
    value: function initializeState() {}
  }, {
    key: "inferParameters",
    value: function inferParameters(column) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var props = this.object.properties;
      var s = new common_1.Scale.LinearScale();
      var values = column.filter(function (x) {
        return typeof x == "number";
      });
      s.inferParameters(values);
      s.adjustDomain(options);
      props.domainMin = s.domainMin;
      props.domainMax = s.domainMax;

      if (!options.reuseRange) {
        props.range = getDefaultGradient();
      }
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      return [manager.sectionHeader("Domain"), manager.row("Start", manager.inputNumber({
        property: "domainMin"
      })), manager.row("End", manager.inputNumber({
        property: "domainMax"
      })), manager.sectionHeader("Gradient"), manager.inputColorGradient({
        property: "range",
        noComputeLayout: true
      }, true)];
    }
  }, {
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var parameters = _get(_getPrototypeOf(LinearColorScale.prototype), "getTemplateParameters", this).call(this);

      if (!parameters.properties) {
        parameters.properties = [];
      }

      parameters.properties.push({
        objectID: this.object._id,
        target: {
          property: "domainMin"
        },
        type: Specification.AttributeType.Number
      });
      parameters.properties.push({
        objectID: this.object._id,
        target: {
          property: "domainMax"
        },
        type: Specification.AttributeType.Number
      });
      return parameters;
    }
  }]);

  return LinearColorScale;
}(index_1.ScaleClass);

LinearColorScale.classID = "scale.linear<number,color>";
LinearColorScale.type = "scale";
LinearColorScale.defaultMappingValues = {
  range: getDefaultGradient()
};
exports.LinearColorScale = LinearColorScale;

var LinearBooleanScale =
/*#__PURE__*/
function (_index_1$ScaleClass3) {
  _inherits(LinearBooleanScale, _index_1$ScaleClass3);

  function LinearBooleanScale() {
    var _this3;

    _classCallCheck(this, LinearBooleanScale);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(LinearBooleanScale).apply(this, arguments));
    _this3.attributeNames = [];
    _this3.attributes = {};
    return _this3;
  }

  _createClass(LinearBooleanScale, [{
    key: "mapDataToAttribute",
    value: function mapDataToAttribute(data) {
      var props = this.object.properties;
      var value = data;

      if (props.inclusive) {
        switch (props.mode) {
          case "greater":
            return value >= props.min;

          case "less":
            return value <= props.max;

          case "interval":
            return value <= props.max && value >= props.min;
        }
      } else {
        switch (props.mode) {
          case "greater":
            return value > props.min;

          case "less":
            return value < props.max;

          case "interval":
            return value < props.max && value > props.min;
        }
      }
    }
  }, {
    key: "buildConstraint",
    value: function buildConstraint(data, target, solver) {}
  }, {
    key: "initializeState",
    value: function initializeState() {}
  }, {
    key: "inferParameters",
    value: function inferParameters(column) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var props = this.object.properties;
      var s = new common_1.Scale.LinearScale();
      var values = column.filter(function (x) {
        return typeof x == "number";
      });
      s.inferParameters(values);
      props.min = s.domainMin;
      props.max = s.domainMax;
      props.mode = "interval";
      props.inclusive = true;
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var props = this.object.properties;
      var minMax = [];

      if (props.mode == "greater" || props.mode == "interval") {
        minMax.push(manager.row(props.inclusive ? ">=" : ">", manager.inputNumber({
          property: "min"
        })));
      }

      if (props.mode == "less" || props.mode == "interval") {
        minMax.push(manager.row(props.inclusive ? "<=" : "<", manager.inputNumber({
          property: "max"
        })));
      }

      return [manager.sectionHeader("Boolean"), manager.row("Mode", manager.inputSelect({
        property: "mode"
      }, {
        type: "dropdown",
        options: ["greater", "less", "interval"],
        showLabel: true,
        labels: ["Greater", "Less", "Interval"]
      })), manager.row("Inclusive", manager.inputBoolean({
        property: "inclusive"
      }, {
        type: "checkbox"
      }))].concat(minMax);
    }
  }]);

  return LinearBooleanScale;
}(index_1.ScaleClass);

LinearBooleanScale.classID = "scale.linear<number,boolean>";
LinearBooleanScale.type = "scale";
LinearBooleanScale.defaultMappingValues = {
  min: 0,
  max: 1,
  mode: "interval",
  inclusive: true
};
exports.LinearBooleanScale = LinearBooleanScale;